import React from "react"
import {ItemRenderer, Select} from "@blueprintjs/select"
import {MenuItem} from "@blueprintjs/core"
import Props from "./props"
import MinimalButton from "./buttons/MinimalButton"
import "./MultiSelect.scss"

const Combobox = Select.ofType<string>()

export interface StringSelectProps extends Props {
    selectedValue: string
    values: string[]
    enabledValues?: string[]
    setSelectedValue: (value: string) => void
    disabled?: boolean
}

const StringSelect: React.FC<StringSelectProps> = (props) => {
    const {
        className,
        id,
        selectedValue,
        setSelectedValue,
        values,
        disabled,
    } = props
    const renderString: ItemRenderer<string> = (
        string,
        {handleClick, modifiers, query}
    ) => {
        if (!modifiers.matchesPredicate) {
            return null
        }
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                text={string}
                key={string}
                onClick={handleClick}
                shouldDismissPopover={false}
            />
        )
    }

    const itemDisabled = (item, index): boolean => {
        return props.enabledValues ? !props.enabledValues.includes(item) : false
    }

    return (
        <div>
            <Combobox
                className={className}
                items={values}
                itemRenderer={renderString}
                onItemSelect={(string: string) => setSelectedValue(string)}
                activeItem={selectedValue}
                filterable={false}
                disabled={disabled}
                itemDisabled={itemDisabled}
            >
                <MinimalButton
                    style={{minWidth: "150px"}}
                    text={selectedValue}
                    rightIcon="caret-down"
                    disabled={disabled}
                    id={id}
                />
            </Combobox>
        </div>
    )
}

StringSelect.defaultProps = {
    disabled: false,
}

export default StringSelect
